/**
 * 案件起票モーダルのフォーム状態型と初期値。
 * ProjectIntakeModal と各ステップ子コンポーネント（Step1Form / Step2Form）が共有する。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 案件起票フォームの内部状態型と初期値の SSOT
 * @graph-connects none
 */

import type { ProjectKind } from '../../../types/project-intake.js';

/** フォーム内部状態。空文字は未入力を表す。 @graph-connects none */
export interface FormState {
  kind: ProjectKind | '';
  business: string;
  team: string;
  plNickname: string;
  mainWorkerNickname: string;
  projectName: string;
  isAbTest: boolean;
  releaseHopeDate: string;
  roughImageUrl: string;
  // プロジェクト憲章（Step 2）
  purpose: string;
  background: string;
  goal: string;
  deliverables: string;
  preconditions: string;
  constraints: string;
  schedule: string;
  cost: string;
  structure: string;
  notes: string;
}

/** フォームの初期値（全項目未入力）。 @graph-connects none */
export const INITIAL_FORM: FormState = {
  kind: '',
  business: '',
  team: '',
  plNickname: '',
  mainWorkerNickname: '',
  projectName: '',
  isAbTest: false,
  releaseHopeDate: '',
  roughImageUrl: '',
  purpose: '',
  background: '',
  goal: '',
  deliverables: '',
  preconditions: '',
  constraints: '',
  schedule: '',
  cost: '',
  structure: '',
  notes: '',
};

/** フォーム 1 項目を更新するセッター。 @graph-connects none */
export type SetFormField = <K extends keyof FormState>(key: K, value: FormState[K]) => void;
